import React, { PureComponent } from 'react';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import styled from 'styled-components';
import SelectField from '../SelectTextField';
import { emptyFieldValidator } from '../../../core/util/rcForm/validators';
import { BIRTH_SEX_FEMALE, BIRTH_SEX_MALE } from '../../../constants/index';
import localizedStr, { EN_US, ES_US, SupportedLocale } from '../../../core/util/localizedStr';
import { neverDefault } from '../../../core/util/neverDefault';
import { capitalize, capitalCase } from '../../../core/util/string';

export const BIRTH_SEX_FIELD = 'birthSex';

const StyledSelect = styled(SelectField)`
  width: 140px;
  margin-right: 10px;
`;
interface Option {
  key: string;
  value: string;
  label: string;
}

const enSexOptions: Option[] = [
  {
    key: '',
    value: '',
    label: '',
  },
  {
    key: BIRTH_SEX_MALE.toLocaleLowerCase(),
    value: BIRTH_SEX_MALE.toLocaleLowerCase(),
    label: capitalize(localizedStr[EN_US].SEX_MALE, { locale: EN_US, lowercaseRest: true }),
  },
  {
    key: BIRTH_SEX_FEMALE.toLocaleLowerCase(),
    value: BIRTH_SEX_FEMALE.toLocaleLowerCase(),
    label: capitalize(localizedStr[EN_US].SEX_FEMALE, { locale: EN_US, lowercaseRest: true }),
  },
];

const esSexOptions: Option[] = [
  enSexOptions[0],
  {
    ...enSexOptions[1],
    label: capitalize(localizedStr[ES_US].SEX_MALE, { locale: ES_US, lowercaseRest: true }),
  },
  {
    ...enSexOptions[2],
    label: capitalize(localizedStr[ES_US].SEX_FEMALE, { locale: ES_US, lowercaseRest: true }),
  },
];

const getValues = (locale: SupportedLocale) => {
  if (locale === EN_US) return enSexOptions;
  if (locale === ES_US) return esSexOptions;
  return neverDefault(locale, enSexOptions);
};

type BirthSexInputProps = {
  form: formShape;
  className?: string;
  label?: string;
  initialValue?: string;
  locale?: SupportedLocale;
};

export default class BirthSexInput extends PureComponent<BirthSexInputProps> {
  getBirthSexProps = () => {
    const { form, label, initialValue, locale = EN_US } = this.props;
    const error = form.getFieldError(BIRTH_SEX_FIELD);
    return {
      ...form.getFieldProps(BIRTH_SEX_FIELD, {
        initialValue,
        validateTrigger: ['onBlur', 'onChange'],
        rules: [
          {
            required: true,
            validator: emptyFieldValidator,
          },
        ],
      }),
      id: BIRTH_SEX_FIELD,
      label: label || capitalCase(localizedStr[locale].PATIENT_SEX, { locale }),
      error: !!error,
      selectOptions: getValues(locale),
    };
  };

  render = () => {
    const { className } = this.props;

    return <StyledSelect className={className} {...this.getBirthSexProps()} />;
  };
}
